import React from 'react';

import {CollapsibleList} from "./collapsible-list";
import {ExpandableFooterShowMoreButton} from "../../expandable-footer/expandable-footer-show-more-button";
import {ExpandableListComposer} from "../../misc/expandable-list-composer";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {List} from "../../misc/list/list";
import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";

export class ExpandableListProps extends BaseProps {
  expanded: Boolean;
  className: String;
  listClassName: String;
  listItemProps: BaseProps;
  children: React.Children;
  ListItem: EntityViewModel;
  expandedList: Array<EntityViewModel>;
  collapsedList: Array<EntityViewModel>;
  toggleExpand: Function;
  keepInDOM: Boolean;
}

export const ExpandableList = ExpandableListComposer((props: ExpandableListProps) => {
  const seeAllProps = {
    ...props,
    onClick: (e) => props.toggleExpand(e)
  }
  return (
    <React.Fragment>
      {
        !!props.collapsedList.length &&
        <List className={props.listClassName} ListItem={props.ListItem} listItemProps={props.listItemProps}
              items={props.collapsedList}/>
      }
      {
        <CollapsibleList open={props.expanded} keepInDOM={props.keepInDOM}>
          {
            <List className={props.listClassName} ListItem={props.ListItem} listItemProps={props.listItemProps}
                  items={props.expandedList}/>
          }
        </CollapsibleList>

      }
      {
        !!props.expandedList.length &&
        <div className={props.className || 'expandable-list-container'}>
          <ExpandableFooterShowMoreButton {...seeAllProps}/>
        </div>
      }
    </React.Fragment>
  )
});
